import React from 'react';
import { Typography } from '@material-ui/core';
import GuideSection from '../../components/GuideSection';
import QuestionsToAsk from './QuestionsToAsk';
import ContentList from './ContentList';
const MeditateSection = () => {
  return (
    <GuideSection>
      <Typography variant="h5" gutterBottom>
        MEDITATE
      </Typography>
      <Typography variant="body1" gutterBottom>
        Practicing meditation helps you know yourself on a deeper level lowering stress and anxiety while creating a
        clear path of direction.
      </Typography>
      <ContentList>
        <Typography variant="body1" gutterBottom>
          <strong>Schedule time daily</strong> to meditate and pray (best way to start your day).
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Find a quiet space</strong> where you can be enriched.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong>Use resources</strong> for better accountability like a calendar or app like Simple Habit
        </Typography>
      </ContentList>
      <QuestionsToAsk
        questions={[
          'Who or what inspires me?',
          'What qualities would I like to possess more of?',
          'Who am I at my most authentic self?'
        ]}
      />
    </GuideSection>
  );
};

export default MeditateSection;
